<template>
  <div>
    <v-toolbar color="grey lighten-4" prominent flat>
      <v-toolbar-title>Налаштування</v-toolbar-title>
    </v-toolbar>
    <v-container>
      <v-row>
        <v-col cols="12" md="8" xl="6">
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>Email</v-expansion-panel-header>
              <v-expansion-panel-content>
                <change-email-form
                  :loading="isEmailLoading"
                  @change-email="onChangeEmail"
                />
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>Пароль</v-expansion-panel-header>
              <v-expansion-panel-content>
                <change-password-form
                  :loading="isPasswordLoading"
                  @change-password="onChangePassword"
                />
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>Інше</v-expansion-panel-header>
              <v-expansion-panel-content>
                <change-profile-form
                  :loading="isProfileLoading"
                  :default-currency="profile.baseCurrency"
                  @change-profile="onChangeProfile"
                />
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import ChangeEmailForm from "@/components/settings/ChangeEmailForm";
import ChangePasswordForm from "@/components/settings/ChangePasswordForm";
import ChangeProfileForm from "@/components/settings/ChangeProfileForm";
import { mapActions } from "vuex";
import { getErrorMessage } from "@/helpers/errors";

export default {
  name: "SettingsPage",
  components: {
    ChangeEmailForm,
    ChangePasswordForm,
    ChangeProfileForm,
  },
  data() {
    return {
      isEmailLoading: false,
      isPasswordLoading: false,
      isProfileLoading: false,
    };
  },
  computed: {
    profile() {
      return this.$store.state.auth.profile;
    },
  },
  methods: {
    ...mapActions([
      "showMessage",
      "changeEmail",
      "changePassword",
      "updateProfile",
      "fetchAccounts",
    ]),
    async onChangeEmail(data) {
      try {
        this.isEmailLoading = true;
        await this.changeEmail(data);
        this.showMessage("Email успішно змінено");
      } catch (error) {
        this.showMessage(getErrorMessage(error));
      } finally {
        this.isEmailLoading = false;
      }
    },
    async onChangePassword(data) {
      try {
        this.isPasswordLoading = true;
        await this.changePassword(data);
        this.showMessage("Пароль успішно змінено");
      } catch (error) {
        this.showMessage(getErrorMessage(error));
      } finally {
        this.isPasswordLoading = false;
      }
    },
    async onChangeProfile(data) {
      try {
        this.isProfileLoading = true;
        await this.updateProfile(data);
        await this.fetchAccounts();
        this.showMessage("Валюта успішно збережена");
      } catch (error) {
        this.showMessage(getErrorMessage(error));
      } finally {
        this.isProfileLoading = false;
      }
    },
  },
};
</script>
